import React from "react";

import { Box } from "@chakra-ui/react";

import { BusinessEmployeesTable } from "./BusinessEmployeesTable";

export const BusinessEmployees = () => {
  return (
    <Box className="mt-1">
      <BusinessEmployeesTable />
    </Box>
  );
};
